.selectList {
  background-color: var(--white);
  color: var(--black);
}
.selectItem {
  text-wrap: nowrap;
}
.selectItem.disabled {
  background-color: var(--white);
  cursor: not-allowed;
  color: var(--borderColor);
}
.selectItem.disabled:hover {
  background-color: var(--white);
}

.popup-container {
  position: absolute;
  background-color: var(--white);
  border-radius: var(--borderRadius);
  border: 1px solid var(--borderColor);
  display: none;
  top: 100%;
  left: 0;
  right: 0;
  z-index: var(--highestZIndex);
  max-height: 200px;
  overflow: auto;
  white-space: nowrap;
}
.popup-container.top {
  transform: translate(0, -100%);
  top: 0;
}
.popup-container.active {
  display: block;
}

.popup-item {
  padding: var(--tinyPadding);
  border-bottom: 1px solid var(--borderColor);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popup-item:hover {
  background-color: var(--buttonActiveColor);
}
.popup-item-icon {
  color: var(--primaryColor);
}

.popup-item-content {
  flex: 1;
  text-align: left;
}

.select-list-container {
  height: 100%;
  text-align: center;
  background-color: var(--white);
  user-select: none;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid var(--borderColor);
  box-sizing: border-box;
}

.select-list-container .select-list-trigger {
  position: absolute;
  right: 0;
  border-radius: unset;
  border-left: 1px solid var(--borderColor);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.select-list-container.active .select-list-trigger {
  transform: rotate(180deg);
  border-right: 1px solid var(--borderColor);
  border-left: none;
}
